<template>
  <el-dialog
    :title="$t('askAnswer.指定用户')"
    :visible.sync="isShow"
    width="600px"
    ref="answerDialogs"
    :close-on-click-modal="false"
    @close="close"
    class="answerDialog"
    round
  >
    <div class="jion-list-contain">
      <el-scrollbar style="height: 100%">
        <ul class="jion-list">
          <li v-for="list in joinedList.filter(item => item.platform != 'sip')">
            <el-radio v-model="user" :label="list.uid"
              >{{ list.name }}</el-radio
            >
            <!--({{ $t(`askAnswer.${list.role}`) }})-->
          </li>
        </ul>
      </el-scrollbar>
    </div>
    <div class="bottom-send-msg">
      <div class="bottom-bar-btn">
        <el-button size="mini" @click="close" class="bottom-bar-btn-cancel">
          {{ $t("askAnswer.取消") }}
        </el-button>

        <el-button
          class="bottom-bar-btn-sure"
          size="mini"
          @click="handlePointer"
          :disabled="user==''"
          >{{ $t("askAnswer.确定") }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { replayUser } from "@/api/liveRequest/askAnswer";
export default {
  name: "pointer",
  data() {
    return {
      chooseUser: "",
      user: ""
    };
  },
  computed: {
    isShow: {
      get() {
        return this.show;
      },
      set(val) {
        console.log(val);
      },
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    joinedList() {
      return this.$store.getters.JoinedList;
    },
    // userId: {
    //   get() {
    //     return this.$store.getters.userInfo?.uid;
    //   },
    //   set(val) {},
    // },
  },
  props: {
    pointer: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    }
  },
  methods: {
    close() {
      this.$emit("closeP");
    },
    async handlePointer() {
      let params = {
        allotUserId: this.user,
        qaId: this.pointer.qaId,
      };
      const { data, code, message } = await replayUser(params, this.liveToken);
      this.$emit("closeP");
      this.user = "";
    },
  },
  watch: {
    // pointer: {
    //   immediate: true,
    //   handler(val) {
    //     console.log("切换的用户", val)
    //     this.user = val.allotUserId;
    //   },
    // },
    id: {
      immediate: true,
      handler(val) {
        console.log("切换的用户", val)
        let isId = false;
        this.joinedList.forEach(item=>{
          if(val === item.uid ){
            isId = true
          }
        })
        console.log(isId,"isId")
        if(isId){
          this.user = val;
        }else{
          this.user = "";
        }
      },
    }
  },
};
</script>
<style scoped lang="scss">
.bottom-send-msg {
  padding: 0 9px;
  margin-top: 20px;
}
.bottom-bar-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px 40px;

  button {
    border: none;
    border-radius: 6px;
  }
  &-cancel {
    background: #37384d;
    color: #acb2bf;
  }
  &-sure {
    background-color: $bule-color;
    color: $white-color;
  }
}
.jion-list {
  li {
    display: flex;
    margin-top: 24px;
  }
  &-contain {
    height: 350px;
    padding-left: 80px;
  }
}
:deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
:deep(.el-radio__label){
  color:#fff
}
</style>
